<template>
    <div class="main noTakeaway orange">
        <Banner :banner="banner"/>
        <Headlines :headlines="headlines"/>

        <div class="content-box">
            <div class="left-box">
                <Article :article="broadcast"/>
                <Shuffling :swiper="coredata"/>
                <Article :article="evaluation"/>
                <Article :article="review"/>
                <Project :project="project"/>
            </div>

            <Rightbox/>
        </div>
    </div>
</template>

<script>
export default {
    name: '2021Q2alcb',
    // meta配置
    metaInfo: {
        title: '【专题】' + '战略亏损 营收不及预期 阿里巴巴2021年二季度财报解读',
        meta: [
            {
                name: 'keywords',
                content: '阿里巴巴 财报 亏损 营收 淘宝 天猫 点淘 盒马 天猫超市 阿里健康 阿里零售通 1688 淘特 闲鱼 淘宝买菜 阿里国际站 全球速卖通 天猫国际 Lazada 考拉海购 菜鸟网络'
            },
            {
                name: 'description',
                content: '8月3日，阿里巴巴发布2022财年一季度财报（即自然年2021年Q2）。财报显示，2022财年第一季度阿里巴巴营收2057.4亿元，同比增长34%，净利润434.4亿元，同比增长10%。那么此次财报到底有怎样的表现？'
            }
        ]
    },
    data() {
        return {
            // 头图标题
            banner: {
                img: require('@/assets/2021Q2alcb/banner.jpg'),
                title: [
                    '战略亏损 营收不及预期',
                    '阿里巴巴2021年二季度财报解读',
                ],
            },

            // 置顶头条
            headlines: [
                {
                    title: '营收不及预期 16张图看懂阿里一季报',
                    url: '/detail--6598932.html'
                },
                {
                    title: '阿里财报：日本软银仍是最大股东 活跃用户近中国人口8成',
                    url: '/detail--6598642.html'
                },
            ],

            // 滚动播报
            broadcast: {
                title: {
                    topic: '滚动播报',
                    more: {
                        name: '我要投诉>',
                        url: '/Index/complain.html'
                    }
                },
                params: {
                    p: 1,
                    n: 5,
                    terms: '阿里 财'
                },
            },

            // 电商快评
            evaluation: {
                title: {
                    topic: '电商快评',
                },
                params: {
                    p: 1,
                    n: 5,
                    terms: '阿里 快评'
                },
            },

            // 核心数据
            coredata: {
                title: {
                    topic: '核心数据',
                    more: {
                        name: '更多数据>',
                        url: '/Index/dsb_product.html',
                    }
                },
                list: [
                    {
                        img: require('@/assets/2021Q2alcb/cb1.jpg'),
                        url: ''
                    },
                    {
                        img: require('@/assets/2021Q2alcb/cb2.jpg'),
                        url: ''
                    },
                    {
                        img: require('@/assets/2021Q2alcb/cb3.jpg'),
                        url: ''
                    },
                    {
                        img: require('@/assets/2021Q2alcb/cb4.jpg'),
                        url: ''
                    },
                    {
                        img: require('@/assets/2021Q2alcb/cb5.jpg'),
                        url: ''
                    },
                    {
                        img: require('@/assets/2021Q2alcb/cb6.jpg'),
                        url: ''
                    },
                    {
                        img: require('@/assets/2021Q2alcb/cb7.jpg'),
                        url: ''
                    },
                ]
            },

            // 网经社点评
            review: {
                title: {
                    topic: '网经社点评',
                },
                nav: [
                    {
                        value: '曹磊 阿里',
                        label: '曹磊'
                    },
                    {
                        value: '莫岱青 阿里',
                        label: '莫岱青'
                    },
                    {
                        value: '陈虎东 阿里',
                        label: '陈虎东'
                    },
                    {
                        value: '鲍跃忠 阿里',
                        label: '鲍跃忠'
                    },
                ],
                params: {
                    p: 1,
                    n: 5,
                    terms: '曹磊 阿里'
                },
            },

            // 相关专题
            project: {
                title: {
                    topic: '相关专题',
                },
                params: {
                    p: 1,
                    name: '行业类',
                    title: '阿里'
                },
            }
        }
    },
}
</script>

<style>

</style>
